import route from 'route';

const mainRoute = route.DASHBOARD;
const billerRoute = `${mainRoute}/allbillers`;

export default {
  FORM_BUILDERS: `${billerRoute}/form-builders`,
  FORM_BUILDERS_FILTER: `${billerRoute}/form-builders/page/:page`,
  FROM_DETAIL: `${billerRoute}/form-builders/:id`,
  AGGREGATORS: `${billerRoute}/aggregators`,
  AGGREGATORS_DETAIL: `${billerRoute}/aggregators/:id`,
  AGGREGATORS_CREATE: `${billerRoute}/aggregators/create`,
  AGGREGATORS_EDIT: `${billerRoute}/aggregators/:id/edit`,
  SERVICES: `${billerRoute}/services`,
  SERVICES_FILTER: `${billerRoute}/services/page/:page`,
  SERVICES_CREATE: `${billerRoute}/services/create`,
  SERVICES_DETAIL: `${billerRoute}/services/:id`,
  SERVICES_EDIT: `${billerRoute}/services/:id/edit`,
  BILLERS: `${billerRoute}/billers`,
  BILLERS_FILTER: `${billerRoute}/billers/page/:page`,
  BILLERS_CREATE: `${billerRoute}/billers/addnew`,
  BILLERS_DETAIL: `${billerRoute}/billers/:id`,
  BILLERS_EDIT: `${billerRoute}/billers/edit/:id`,
  CONFIGS: `${billerRoute}/configs`,
  TRANSACTIONS: `${billerRoute}/transactions`,
  TRANSACTIONS_FILTER: `${billerRoute}/transactions/page/:page`,
  TRANSACTION_META: `${billerRoute}/transactions/meta`,
  TNC_LIST: `${billerRoute}/tnc`,
  TNC_LIST_FILTER: `${billerRoute}/tnc/page/:page`,
  TNC_CREATE: `${billerRoute}/tnc/create`,
  TNC_DETAIL: `${billerRoute}/tnc/detail/:id`,
  TNC_EDIT: `${billerRoute}/tnc/:id/edit`,

  // SETTLEMENT: `${billerRoute}/settlement`,
  // SETTLEMENT_FILTER: `${billerRoute}/settlement/page/:page`,
};
